import type {
    ConsentFormVersionResponse,
    PrivacyPolicyResponse,
} from "@lbcrm-api/church-texts/church-texts.responses";
import { defaultAxios } from "src/authentication/context/AuthenticationProvider";
import useSWR from "swr";

/** Read before anybody signs in, so never through the signed-in client */
const fetchPublic = async <T>(url: string) => (await defaultAxios.get<T>(url)).data;

/** The church's privacy policy, fetched only once something asks to show it */
export const usePrivacyPolicy = (wanted = true) => {
    const { data, error } = useSWR<PrivacyPolicyResponse>(wanted ? "/public/privacy-policy" : null, fetchPublic);

    return { policy: data, error };
};

/** The church's consent wording as it stands, which a form being filled in is signed on */
export const useConsentFormWording = () => {
    const { data, error, mutate } = useSWR<ConsentFormVersionResponse>("/public/consent-form", fetchPublic);

    return { wording: data, error, mutate };
};

/** A consent's question as the parent reads it, with `{child}` as the child's first name */
export const forChild = (text: string, childFirstName: string) => text.split("{child}").join(childFirstName);
